import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Search, Calendar } from "src/components";
import { DateService, _ } from "src/services";
import { TvModel, TvAction } from "src/store";
import { TvModelDatePicker } from "./tv.conductor.date.picker";

export const TvConductorListSearch: React.FC = () => {

    //#region Dependencies

    const dispatch = useDispatch();
    const conductor: TvModel = useSelector((state: any) => state.TvState);

    //#endregion

    //#region states

    const [calendarOpen, setCalendarOpen] = useState(false);

    //#endregion

    //#region  methods

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        dispatch(TvAction.setSearchText(value));
    };

    const toggleCalendar = () => setCalendarOpen((x) => !x);

    const resetDate = () => {
        if (conductor.currentDate) dispatch(TvAction.setCurrentDate(undefined));
        dispatch(TvAction.setCurrentEpisode(undefined));
    };

    //#endregion

    const showReturnToLive = conductor.currentDate || (conductor.episode && !conductor.episode.currentProgram);

    return (
        <>
            <div className="row m-0 d-flex justify-content-center px-3">
                <div className="search-container flex-grow-1">
                    <div className="search-icon float-right">
                        <Search />
                    </div>
                    <input
                        value={conductor.searchText || ""}
                        onChange={onChange}
                        placeholder={_("search")}
                        type="text"
                        className="search-input float-right text-rtl"
                    />
                </div>
                <div className={`calendar-icon ml-2${showReturnToLive ? " history" : ""}`} onClick={toggleCalendar}>
                    <span className="m-auto d-block calendar-svg">
                        <Calendar />
                    </span>
                    {showReturnToLive && <div className="badge-history" />}
                </div>
            </div>
            <div className="row mx-0 px-3 my-2">
                <div className="col-6 date">
                    {
                        conductor.currentDate ?
                            DateService.persianDate(conductor.currentDate, "dddd DD MMMM") :
                            DateService.persianDate(new Date(), "YYYY/MM/DD")
                    }
                </div>
                {
                    !showReturnToLive &&
                    <div className="col-6 text-right date">{_("today")}</div>
                }
                {
                    showReturnToLive &&
                    <button onClick={resetDate} className="col-6 btn btn-submit btn-back" >{_("returnToLive")}</button>
                }
            </div>
            {calendarOpen && <TvModelDatePicker toggleCalendar={toggleCalendar} />}
        </>
    );

};